import { render } from "./HeaderPage.vue?vue&type=template&id=f2b7c838&scoped=true"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import "./HeaderPage.vue?vue&type=style&index=0&id=f2b7c838&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b7c838"]])

export default __exports__